"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extension = void 0;
const mime_types_1 = __importDefault(require("mime-types"));
const extension = fileName => {
    const type = mime_types_1.default.contentType(fileName);
    if (!type)
        return fileName.split('.').pop();
    return mime_types_1.default.extension(type);
};
exports.extension = extension;
//# sourceMappingURL=utils.js.map